import { render, staticRenderFns } from "./Legend.vue?vue&type=template&id=748ea02a&scoped=true&"
import script from "./Legend.vue?vue&type=script&lang=js&"
export * from "./Legend.vue?vue&type=script&lang=js&"
import style0 from "./Legend.vue?vue&type=style&index=0&id=748ea02a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "748ea02a",
  null
  
)

export default component.exports